import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/home/HeroSection";
import AboutSection from "@/components/home/AboutSection";
import ValuesSection from "@/components/home/ValuesSection";
import ProductsSection from "@/components/home/ProductsSection";
import CertificationsSection from "@/components/home/CertificationsSection";
import ContactSection from "@/components/home/ContactSection";
import GlobalPresenceSection from "@/components/home/GlobalPresenceSection";
import MaterialsSection from "@/components/home/MaterialsSection";
import PharmacySection from "@/components/home/PharmacySection";
import LogisticsSection from "@/components/home/LogisticsSection";
import ClientsSection from "@/components/home/ClientsSection";
import logisticsWarehouse from "@/assets/logistics-warehouse.jpg";

const Index = () => {
  // Update page title for SEO
  useEffect(() => {
    document.title = "AMS DISTRIB | Fournisseur Emballage Alimentaire Bordeaux, Toulouse, Paris";
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main id="main-content" role="main">
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <GlobalPresenceSection />
        <MaterialsSection />
        <LogisticsSection warehouseImage={logisticsWarehouse} />
        <ClientsSection />
        <PharmacySection />
        <ValuesSection />
        <CertificationsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
